import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

export interface UiMenuSidebarItem {
  value: string;
  label: string;
  disabled?: boolean;
  /** Título opcional mostrado antes del elemento. */
  sectionTitle?: string;
}

/**
 * Organismo: barra lateral de navegación solo texto.
 *
 * Misma huella visual que `ui-app-sidebar` expandido (240px), sin iconos
 * y sin modo colapsado. Solo presentación; sin HTTP ni Router.
 */
@Component({
  selector: 'ui-menu-sidebar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './menu-sidebar.component.html',
  styleUrl: './menu-sidebar.component.scss',
  host: {
    class: 'ui-menu-sidebar-host',
  },
})
export class UiMenuSidebarComponent {
  /** Lista de ítems de navegación */
  readonly items = input<readonly UiMenuSidebarItem[]>([]);

  /** Valor del ítem actualmente seleccionado */
  readonly selectedValue = input<string | null>(null);

  /** Etiqueta accesible del elemento `<nav>` */
  readonly ariaLabel = input('Navegación');

  /** Emite el `value` del ítem seleccionado */
  readonly itemSelect = output<string>();

  protected onItemClick(item: UiMenuSidebarItem): void {
    if (item.disabled) return;
    this.itemSelect.emit(item.value);
  }
}
